import { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../actions/AppActions';
import { correctionReportRequest, reportQuery } from './services';
function useContext() {
  const { token, user } = useSelector(state => state.AppReducer), dispatch = useDispatch();
  return { token, user, onError: error => { if (error.status === 401) dispatch(logout()); } };
}
export function useCorrectionOptions(facultyId, processId, kind = 'essay') {
  const { token, user, onError } = useContext();
  return useQuery(['dashboard-corrections', user?.id, facultyId, processId || 'all', 'options', kind], () => correctionReportRequest(token, facultyId, '/opcoes?' + reportQuery({ processo_id: processId, options_kind: kind })), { enabled: !!token && !!facultyId, retry: false, staleTime: 60000, onError });
}
export function useCorrectionRows(facultyId, filters, enabled) {
  const { token, user, onError } = useContext();
  return useQuery(['dashboard-corrections', user?.id, facultyId, 'rows', filters], () => correctionReportRequest(token, facultyId, '?' + reportQuery(filters)), { enabled: !!token && enabled, retry: false, keepPreviousData: true, onError });
}
export function useCorrectionExport(facultyId, processId) {
  const { token, user, onError } = useContext(), cache = useQueryClient();
  return useMutation(filters => correctionReportRequest(token, facultyId, '/execucoes', 'POST', filters), { onSuccess: () => cache.invalidateQueries(['dashboard-corrections', user?.id, facultyId, 'runs', processId || 'all']), onError });
}
export function useCorrectionRuns(facultyId, processId, page) {
  const { token, user, onError } = useContext();
  return useQuery(['dashboard-corrections', user?.id, facultyId, 'runs', processId || 'all', page], () => correctionReportRequest(token, facultyId, '/execucoes?' + reportQuery({ processo_id: processId, page })), { retry: false, keepPreviousData: true, refetchInterval: data => data?.jobs?.some(job => ['0', '1'].includes(job.status)) ? 3000 : false, onError });
}

export function useReportSearch(value) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => { const timer = setTimeout(() => setDebounced(value), 350); return () => clearTimeout(timer); }, [value]);
  return debounced;
}
